
const teamData = {

	title: "Our Team",
	team: [
		{
			image: {
				src: "/assets/images/team/tracey.jpg",
				alt: "Tracey Henry",
			},
			name: "Tracey Henry",
			title: "CEO",
		},
		{
			image: {
				src: "/assets/images/team/Riekie_Van_Tonder.jpg",
				alt: "Riekie van Tonder",
			},
			name: "Riekie van Tonder",
			title: "Head: Finance and Risk",
		},
		{
			image: {
				src: "/assets/images/team/Thandi-Lekeba.png",
				alt: "Thandi Lekeba ",
			},
			name: "Thandi Lekeba ",
			title: "Programme Manager",
		},
		{
			image: {
				src: "/assets/images/team/Mmakgosi_Chaane-Pule.png",
				alt: "Mmakgosi Chaane-Pule",
			},
			name: "Mmakgosi Chaane-Pule",
			title: "Programme Manager",
		},
		{
			image: {
				src: "/assets/images/team/bongekile.png",
				alt: "Bongekile Ndlela",
			},
			name: "Bongekile Ndlela",
			title: "Programme Manager",
		},
		{
			image: {
				src: "/assets/images/team/donnah_nhlema.jpg",
				alt: "Donnah Nhlema",
			},
			name: "Donnah Nhlema",
			title: "Social Investment Risk Execution Officer",
		},
		{
			image: {
				src: "/assets/images/team/campbell.jpg",
				alt: "Althea Campbell",
			},
			name: "Althea Campbell",
			title: "PA",
		},
		// {
		// 	image: {
		// 		src: "/assets/images/team/Lethokuhle_Gamede.jpg",
		// 		alt: "Lethokuhle Gamede",
		// 	},
		// 	name: "Lethokuhle Gamede",
		// 	title: "PA to CEO and Team Assistant",
		// },

	],

}

export { teamData };
